import { useTranslation } from 'react-i18next';
import { parseJwt, sendToErrorTracking } from '@lamimed/utils';
import { useRouter } from 'next/router';
import useSWR from 'swr';

import { User } from 'models/User';

import { AppointmentSummary } from 'types/appointment';

import { authTokenStorageKey } from 'hooks/useAuthentication';
import { useStorage } from 'hooks/useStorage';

import { axiosFactory } from 'utils/http/axiosFactory';

import { useGetAppointmentId } from './useGetAppointmentId';

export const useUserAppointments = () => {
  const { i18n } = useTranslation();
  const router = useRouter();
  const { appointmentId } = useGetAppointmentId();
  const { get } = useStorage();
  const fetcher = axiosFactory(i18n.language, 'attendence');

  const authToken = get(authTokenStorageKey);

  const { data, error, isValidating, isLoading } = useSWR<AppointmentSummary[]>(
    `/appointment/patient/${parseJwt<User>(authToken)?.user_id}?with_files=1`,
    async (url: string) => {
      const authorization = `Bearer ${JSON.parse(get(authTokenStorageKey))}`;

      const { data } = await fetcher.get(url, {
        headers: {
          authorization,
        },
      });

      return data;
    },
  );

  if (error) {
    sendToErrorTracking({
      error,
      where: 'useDetailedAppointment',
      context: {
        ...router.query,
      },
    });
  }

  return {
    appointmentId,
    data,
    error,
    isLoading: !data && isValidating,
    isInitialLoading: isLoading,
    isValidating,
  };
};
